<template>
    <div id="apply-to-join-layout">
        <component :is="`${capitalizeFirstLetter(locale)}Pricing`" :prices="prices"/>

        <section id="prices-section" class="pt-5">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h1>
                            Unlock discounts when you
                            <nobr>pre-purchase</nobr>
                            credits.
                        </h1>
                        <div class="steps">
                            <div><strong>1.</strong> Pre-purchase credits</div>
                            <div><strong>2.</strong> Website will show discounted prices</div>
                            <div><strong>3.</strong> Download any {{ locale === 'nz' ? 'image/videos' : 'image' }}.</div>
                        </div>
                    </div>
                </div>
                <div class="row d-none d-md-flex">
                    <div class="col-12 text-center mb-0 mb-md-5">
                        <b-button id="pricing-discount-sample-btn" v-b-modal.discount-sample-modal>
                            See pricing with discounts applied
                            <b-icon-arrow-up-right/>
                        </b-button>
                    </div>
                </div>
                <div class="row price-cols-bs-row">
                    <div v-for="(creditPack, index) in creditPacks" :key="creditPack.id" class="col-sm-12 col-md-6 col-lg-3" :class="{'preferred':index === 1}">
                        <div class="price-col">
                            <!--                            <div v-if="creditPack.credits === 3000 && locale === 'nz'" class="mini-heading" style="font-size: 1.25rem;">EASTER 2024 SPECIAL DEAL</div>-->
                            <div v-if="index === 1" class="mini-heading">Most Popular</div>
                            <div class="discount-amt">
                                <a @click="buy(creditPack)">
                                    <!--                                    <div v-if="creditPack.discount === 25 && locale === 'nz'" style="font-size:0.8rem">-->
                                    <!--                                        <div class="discount-pcnt mb-2">{{ creditPack.discount }}%</div>-->
                                    <!--                                        off all content <br>for 6 months from <br>purchase. Then rolls <br>to 15% off.-->
                                    <!--                                    </div>-->
                                    <div>
                                        <div class="discount-pcnt">{{ creditPack.discount }}%</div>
                                        off all
                                        <br>
                                        {{ locale === 'nz' ? 'images &amp; videos' : 'images' }}
                                    </div>
                                </a>
                            </div>
                            <div class="pp-txt">pre-purchase</div>
                            <div class="price">${{ creditPack.credits }}</div>
                            <a class="btn btn-primary buy-now-btn" @click="buy(creditPack)">Buy Now</a>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-6 col-lg-3 corporate">
                        <div class="price-col corporate-account-col">
                            <div>
                                <a href="#corporate-accounts">Invoiced Accounts</a>
                            </div>
                            <ul>
                                <li>Credit card no longer needed</li>
                                <li>Pre-purchase credits <br>via invoice</li>
                                <li>Credits never expire</li>
                                <li>We'll fill in relevant <br>Supplier Forms where needed</li>
                                <li>Dedicated account manager</li>
                                <li>Image search assistance</li>
                                <li>Discounts</li>
                            </ul>
                            <a class="btn buy-now-btn btn-color learn-link" href="#corporate-accounts">Learn More</a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-8 offset-md-2 mt-5 pt-0 pt-md-5">
                        <b-button-group class="w-100 faq-buttons">
                            <b-button v-b-modal.contact-modal>
                                Registered Charities and NGOs get 20% off. <span class="underlined">Contact us to get discount</span>
                            </b-button>
                        </b-button-group>
                    </div>
                </div>
            </div>
        </section>

        <section id="corporate-accounts">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-10 offset-md-1 text-center text-heading">
                        Invoiced Accounts
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-10 offset-md-1 text-center text">
                        Get the flexibility of not needing a credit card for each transaction. Your account will be <strong>credited with the invoiced amount.</strong> Your team can then download images without the need for a credit card.
                        <strong>Discounts</strong> available based on budget.
                    </div>
                </div>
            </div>
        </section>

        <section id="benefits-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 col-sm-12 heading">
                        Invoiced instead of one-off Credit Card payments
                    </div>
                    <div class="col-lg-7 offset-lg-1 col-md-8 col-sm-12 text">
                        <p class="mb-4">
                            We can discuss a monthly or annual budget to give your team access to images on-the-go without the need for a company credit card for every purchase.
                        </p>
                        <p class="mb-4">
                            Your <strong>account will be credited</strong> with the agreed invoice amount and a pre-discussed blanket discount will be applied to <strong>all prices</strong> no matter how much you spend every month.
                        </p>
                        <p class="mb-4">
                            We can work around your invoicing preference whether it be monthly, quarterly or annually.
                        </p>
                        <img :src="`${assetsUrl}credits-screenshot.png`">
                    </div>
                </div>
                <div class="row divider-row">
                    <div class="col-12">
                        <div class="divider-0"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-12 heading">
                        All prices will appear with the discussed discount applied.<br>
                        <span>Example only for illustration, shown with 15% discount applied.</span>
                    </div>
                    <div class="col-lg-7 offset-lg-1 col-md-8 col-sm-12 text">
                        <img :src="`${assetsUrl}discounts-screenshot.png`">
                    </div>
                </div>
                <div class="row divider-row">
                    <div class="col-12">
                        <div class="divider-0"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-12 heading">
                        Pay for any image or size using credits instead of a Credit Card
                    </div>
                    <div class="col-lg-7 offset-lg-1 col-md-8 col-sm-12 text">
                        <img :src="`${assetsUrl}cart-credits-screenshot.png`">
                    </div>
                </div>
                <div class="row divider-row">
                    <div class="col-12">
                        <div class="divider-0"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-12 heading">
                        Add team members
                    </div>
                    <div class="col-lg-7 offset-lg-1 col-md-8 col-sm-12 text">
                        <p>You can easily add other team members through your dashboard, and set their <strong>permission levels</strong> to have varying levels of control on the account and ability to download images.</p>
                    </div>
                </div>
                <div class="row divider-row">
                    <div class="col-12">
                        <div class="divider-0"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-12 heading">
                        Topping up your account
                    </div>
                    <div class="col-lg-7 offset-lg-1 col-md-8 col-sm-12 text">
                        <p>You can top-up your account anytime by contacting your dedicated account manager. Your discount will remain at the discussed percentage when your account was first created.</p>
                    </div>
                </div>
                <div class="row divider-row">
                    <div class="col-12">
                        <div class="divider-0"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-12 heading">
                        Other benefits
                    </div>
                    <div class="col-lg-7 offset-lg-1 col-md-8 col-sm-12 text">
                        <p>We can also assist in image searches and offer insights into upcoming photoshoots.</p>
                    </div>
                </div>
                <div class="row divider-row">
                    <div class="col-12">
                        <div class="divider-0"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center ">
                        <b-link v-b-modal.corporate-contact-modal class="btn btn-primary contact-btn mb-4">Contact us to get started</b-link>
                    </div>
                </div>
            </div>
        </section>

        <b-modal id="discount-sample-modal" centered size="lg" scrollable hide-footer>
            <template #modal-title>Pricing with discounts applied</template>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <p>What you'll pay based on discount amount. You can buy any size content with the credits.</p>
                        <table id="pricing-discount-table" class="table">
                            <thead>
                                <tr>
                                    <th>Size</th>
                                    <th>Standard</th>
                                    <th v-for="creditPack in creditPacks" :key="creditPack.id">{{ creditPack.discount }}% off</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="price in getDefaultPrices('image')">
                                    <th>{{ sizeNames[price.size] }}</th>
                                    <td>{{ moneyOptionalDecimal(price.amount) }}</td>
                                    <td v-for="creditPack in creditPacks" :key="creditPack.id">{{ moneyOptionalDecimal(price.amount - (price.amount * creditPack.discount / 100)) }}</td>
                                </tr>
                                <template v-if="locale === 'nz'">
                                    <tr v-for="price in getDefaultPrices('video')">
                                        <th>{{ price.size }}</th>
                                        <td>{{ moneyOptionalDecimal(price.amount) }}</td>
                                        <td v-for="creditPack in creditPacks" :key="creditPack.id">{{ moneyOptionalDecimal(price.amount - (price.amount * creditPack.discount / 100)) }}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal id="modal-pre-purchase" centered size="xl" scrollable hide-footer :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-header-close="checkingOut">
            <template #modal-title>Pre-Purchase</template>
            <div class="container">
                <loading :loading="checkingOut" :full-page="true"/>
                <div id="checkoutContentRow" class="row">
                    <div id="checkoutContentCol" class="col-md-12 col-lg-6">
                        <div class="checkout-billing-area">
                            <template v-if="user">
                                <PaymentMethods ref="paymentMethods" :stripe-js-loaded="stripeJsLoaded" :total="total" :sub-total="subTotal" :allow-credits="false" @ready="setPaymentMethodReady"/>
                                <div class="content-heading">
                                    Billing Details
                                </div>
                                <div class="divider-0"/>
                                <div>
                                    <billing-form v-if="(!userHasBillingInfo() || editBillingInfo) && (user.account_type === 'personal' || user.permissions.includes('MANAGE_BILLING'))" ref="billingDetails" :show-submit="false"/>
                                    <div v-else>
                                        <div v-if="user.account_type === 'business'" class="billing-txt">
                                            {{ user.alternateBilling && user.alternateBilling.name ? user.alternateBilling.name : user.business_name }}
                                        </div>
                                        <div class="billing-txt">
                                            {{ user.alternateBilling && user.alternateBilling.address ? user.alternateBilling.address : user.address }}
                                        </div>
                                        <div class="billing-txt">
                                            {{ user.alternateBilling && user.alternateBilling.suburb ? user.alternateBilling.suburb : user.suburb }}
                                        </div>
                                        <div class="billing-txt">
                                            {{ user.alternateBilling && user.alternateBilling.city ? user.alternateBilling.city : user.city }}
                                        </div>
                                        <div class="billing-txt">
                                            {{ user.alternateBilling && user.alternateBilling.country ? user.alternateBilling.country.name : user.country.name }}
                                            {{ user.alternateBilling && user.alternateBilling.postcode ? user.alternateBilling.postcode : user.postcode }}
                                        </div>
                                        <a v-if="user.account_type === 'personal' || user.permissions.includes('MANAGE_BILLING')" class="btn btn-default btn-hollow" @click="editBilling">Edit Billing Details</a>
                                    </div>
                                    <div v-if="user.account_type === 'business' && !userHasBillingInfo() && !user.permissions.includes('MANAGE_BILLING')" class="alert  alert-warning">
                                        Your account isn't allowed to edit billing details
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <template v-if="registerNew">
                                    <register-form :industries="industries" :full-width="true"/>
                                    <a class="auth-link" @click="toggleRegisterNew">Already have an account</a>
                                </template>
                                <template v-else>
                                    <login-form/>
                                    <a class="auth-link" @click="toggleRegisterNew">Register a new account</a>
                                </template>
                            </template>
                        </div>
                        <div class="divider-3"/>
                    </div>
                    <div class="col-md-12 col-lg-6">
                        <form @submit.prevent="pay()">
                            <table class="checkout-table">
                                <tr>
                                    <td>Pre-Purchase Credit</td>
                                    <td class="amt">{{ moneyForceDecimal(subTotal) }}</td>
                                </tr>
                                <tr v-if="gst > 0">
                                    <td class="total-txt">
                                        GST ({{ localeVariables['gst-pcnt'] }}%)
                                    </td>
                                    <td class="amt">
                                        {{ moneyForceDecimal(gst) }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="total-txt font-weight-bold">
                                        Total
                                    </td>
                                    <td class="amt">
                                        {{ moneyForceDecimal(total) }}
                                    </td>
                                </tr>
                            </table>
                            <div class="row mt-4">
                                <div class="col-12">
                                    <a class="btn btn-outline-primary float-left w-auto pl-5 pr-5" @click="$bvModal.hide('modal-pre-purchase')">Cancel</a>
                                    <v-button
                                        type="submit"
                                        class="btn btn-primary float-right w-auto pl-5 pr-5"
                                        :disabled="checkoutUnavailable"
                                        :loading="form.busy"
                                    >
                                        {{ total > 0 ? 'Make Payment' : 'Buy Now' }}
                                    </v-button>
                                </div>
                            </div>
                            <div class="divider-2"/>
                        </form>
                    </div>
                </div>
            </div>
        </b-modal>

        <corporate-modal/>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import Form from 'vform'
import Swal from 'sweetalert2'
import CorporateModal from '~/components/CorporateContactModal'
import LoginForm from '~/components/auth/LoginForm'
import RegisterForm from '~/components/auth/RegisterForm'
import BillingForm from '~/components/auth/BillingForm'
import PaymentMethods from '~/components/checkout/PaymentMethods.vue'

import NzPricing from '~/components/pricing/NzPricing'
import AusPricing from '~/components/pricing/AusPricing'

export default {
    components: {
        PaymentMethods,
        CorporateModal,
        BillingForm,
        RegisterForm,
        LoginForm,
        NzPricing,
        AusPricing
    },
    async asyncData () {
        const fetchedCreditPacks = await axios.get('/credit-packs').then(rsp => rsp.data)
        const fetchedPrices = await axios.get('/prices').then(rsp => rsp.data)

        return {
            creditPacks: fetchedCreditPacks,
            prices: fetchedPrices
        }
    },
    data () {
        return {
            creditPacks: [],
            prices: [],
            registerNew: false,
            payError: null,
            editBillingInfo: false,
            checkingOut: false,
            paymentMethodReady: false,
            form: new Form({
                saveCard: false,
                paymentMethodType: null,
                tokenData: null,
                selectedPack: {}
            }),
            stripeJsLoaded: false,
            sizeNames: {
                xs: 'Extra Small',
                s: 'Small',
                m: 'Medium',
                l: 'Large',
                xl: 'Extra Large'
            }
        }
    },
    head () {
        return {
            title: 'Truestock Invoiced Accounts and Pre-purchase Discounts',
            script: [
                {
                    hid: 'stripe',
                    src: 'https://js.stripe.com/v3/',
                    defer: true,
                    callback: () => {
                        this.stripeJsLoaded = true
                    }
                }
            ]
        }
    },
    computed: {
        ...mapGetters({
            industries: 'data/industries',
            user: 'auth/user',
            licences: 'data/licences',
            localeVariables: 'data/localeVariables'
        }),
        subTotal () {
            return parseFloat(this.form.selectedPack.price)
        },
        gst () {
            return this.subTotal * (parseFloat(this.localeVariables['gst-pcnt']) / 100)
        },
        total () {
            return this.subTotal + this.gst
        },
        checkoutUnavailable () {
            // return !this.user || (this.total > 0 && (!this.user.permissions.includes('PURCHASE_WITH_CARD') || (!this.paymentMethod && !this.$refs.creditCard && !this.user.permissions.includes('MANAGE_BILLING'))))
            return !this.user || !this.paymentMethodReady
        }
    },
    mounted () {
        this.$nextTick(() => {
            if (this.$route.hash) {
                const el = document.querySelector(this.$route.hash)
                el && el.scrollIntoView()
            }
        })
    },
    methods: {
        getDefaultPrices (type) {
            const defaultLicence = this.licences[type].find(licence => licence.default === 1)
            const defaultPriceTier = defaultLicence.tiers.find(tier => tier.default === 1)

            return this.prices.filter(price => price.default === 1 &&
                price.stock_licence_id === defaultLicence.id &&
                price.stock_price_tier_id === defaultPriceTier.id &&
                price.amount !== null
            )
        },
        setPaymentMethodReady (status) {
            this.paymentMethodReady = status
        },
        buy (creditPack) {
            this.form.selectedPack = creditPack
            this.paymentMethodReady = false

            this.$gtag.event('begin_checkout', {
                value: parseFloat(creditPack.price),
                currency: this.localeVariables.currency,
                items: [{
                    item_id: 'credit-' + creditPack.id,
                    item_name: 'Credits $' + creditPack.credits,
                    quantity: 1,
                    price: parseFloat(creditPack.price)
                }]
            })

            this.$bvModal.show('modal-pre-purchase')
        },
        toggleRegisterNew () {
            this.registerNew = !this.registerNew
        },
        editBilling () {
            if (!this.form.busy) {
                this.editBillingInfo = true
            }
        },
        userHasBillingInfo () {
            return this.user.address && this.user.address !== '' &&
                this.user.suburb && this.user.suburb !== '' &&
                this.user.city && this.user.city !== '' &&
                this.user.postcode && this.user.postcode !== ''
        },
        async pay () {
            this.$toast.clear()
            this.checkingOut = true
            this.payError = null

            if (this.user) {
                let billingResponse = true
                if (!this.userHasBillingInfo() || this.editBillingInfo) {
                    billingResponse = await this.$refs.billingDetails.update()
                }

                if (billingResponse) {
                    const paymentMethodReady = await this.$refs.paymentMethods.isPaymentMethodReady()

                    if (paymentMethodReady) {
                        this.form.paymentMethodType = this.$refs.paymentMethods.getPaymentMethodType()

                        await this.doCheckout()
                    } else {
                        await this.doCcPayment()
                    }
                } else {
                    this.checkingOut = false
                }
            } else {
                this.checkingOut = false
            }
        },
        async doCcPayment () {
            if (this.total > 0) {
                const ccData = await this.$refs.paymentMethods.getCreditCardToken()

                this.form.tokenData = ccData.tokenData
                this.form.saveCard = ccData.saveCard

                if (ccData && this.form.tokenData && this.form.tokenData.error) {
                    this.$toast.error(this.form.tokenData.error.message)
                    this.checkingOut = false
                } else {
                    this.form.paymentMethodType = this.$refs.paymentMethods.getPaymentMethodType()

                    await this.doCheckout()
                }
            } else {
                this.form.paymentMethodType = this.$refs.paymentMethods.getPaymentMethodType()

                await this.doCheckout()
            }
        },
        async doCheckout () {
            this.form.cart = this.items

            await this.form.post('/checkout/pre-purchase')
                .then(data => data.data)
                .then((data) => {
                    this.checkingOut = false

                    const amt = this.form.selectedPack.credits

                    this.$gtag.event('purchase', {
                        value: parseFloat(this.form.selectedPack.price),
                        currency: this.localeVariables.currency,
                        items: [{
                            item_id: 'credit-' + this.form.selectedPack.id,
                            item_name: 'Credits $' + this.form.selectedPack.credits,
                            quantity: 1,
                            price: parseFloat(this.form.selectedPack.price)
                        }]
                    })

                    this.$bvModal.hide('modal-pre-purchase')

                    Swal.fire({
                        icon: 'success',
                        title: 'Pre-Purchase Successful!',
                        html: this.user.discount_fixed ? `${this.moneyOptionalDecimal(amt)} credit has been added to your account.` : `${this.moneyOptionalDecimal(amt)} credit and a ${data.purchase.discount_combined}% discount have been added to your account.`,
                        confirmButtonText: 'OK'
                    })

                    this.$store.dispatch('auth/fetchUser')
                }).catch((e) => {
                    this.checkingOut = false

                    if (e.response.status === 422 && e.response.data.errors.content_licence_agreement) {
                        this.$toast.error('You must accept the Content Licence Agreement')
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Payment failed!',
                            html: `Reason: ${e.response.data.message}<br/><br/>If you continue to experience issues, message us at <a href="mailto:${this.notificationEmail}">${this.notificationEmail}</a>`,
                            confirmButtonText: 'OK'
                        })
                    }
                })
        }
    }
}
</script>
